(function () {
  function initHeader(header) {
    var toggle = header.querySelector('[data-dn-menu-toggle]');
    var panel = header.querySelector('.dn-mobile-menu');
    if (!toggle || !panel) return;

    function setMenuOpen(open) {
      if (open) {
        panel.removeAttribute('hidden');
        toggle.setAttribute('aria-expanded', 'true');
        header.classList.add('dn-header--menu-open');
        document.body.classList.add('dn-header-menu-open');
      } else {
        panel.setAttribute('hidden', '');
        toggle.setAttribute('aria-expanded', 'false');
        header.classList.remove('dn-header--menu-open');
        document.body.classList.remove('dn-header-menu-open');
      }
    }

    toggle.addEventListener('click', function () {
      setMenuOpen(panel.hasAttribute('hidden'));
    });
  }

  function initAll() {
    document.querySelectorAll('.dn-header').forEach(initHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
